/**
 * Mount Payroc Hosted Fields (card). Call destroy on cleanup.
 * @param {object} options
 * @param {string} options.sessionToken - Hosted Fields session token (from POST /hosted-fields-sessions).
 * @param {function(object): void} options.onSubmissionSuccess - ({ token, expiresAt }) => void
 * @param {function(object): void} [options.onError]
 * @param {string} [options.submitLabel]
 * @returns {{ destroy: function(): void }}
 */
export function mountPayrocCardHostedFields({
  sessionToken,
  onSubmissionSuccess,
  onError,
  submitLabel = 'Submit Payment',
}) {
  const HostedFields = window.Payroc.hostedFields;
  const hosted = new HostedFields({
    sessionToken,
    mode: 'payment',
    fields: {
      card: {
        cardholderName: {
          target: '.rhinopay-payroc-card .payroc-card-holder-name',
          errorTarget: '.rhinopay-payroc-card .payroc-card-holder-name-error',
          placeholder: 'Cardholder Name',
        },
        cardNumber: {
          target: '.rhinopay-payroc-card .payroc-card-number',
          errorTarget: '.rhinopay-payroc-card .payroc-card-number-error',
          placeholder: '1234 5678 1234 1211',
        },
        cvv: {
          wrapperTarget: '.rhinopay-payroc-card .payroc-card-cvv-wrapper',
          target: '.rhinopay-payroc-card .payroc-card-cvv',
          errorTarget: '.rhinopay-payroc-card .payroc-card-cvv-error',
          placeholder: 'CVV',
        },
        expiryDate: {
          target: '.rhinopay-payroc-card .payroc-card-expiry',
          errorTarget: '.rhinopay-payroc-card .payroc-card-expiry-error',
          placeholder: 'MM/YY',
        },
        submit: {
          target: '.rhinopay-payroc-card .payroc-card-submit',
          value: submitLabel,
        },
      },
    },
  });

  hosted.on('submissionSuccess', onSubmissionSuccess);
  if (onError) {
    hosted.on('error', onError);
  }
  hosted.initialize();

  return {
    destroy: () => {
      if (typeof hosted.destroy === 'function') {
        hosted.destroy();
      }
    },
  };
}

/**
 * Mount Payroc Hosted Fields (ACH). Call destroy on cleanup.
 */
export function mountPayrocAchHostedFields({
  sessionToken,
  onSubmissionSuccess,
  onError,
  submitLabel = 'Submit Payment',
}) {
  const HostedFields = window.Payroc.hostedFields;
  const hosted = new HostedFields({
    sessionToken,
    mode: 'payment',
    fields: {
      ach: {
        nameOnAccount: {
          target: '.rhinopay-payroc-ach .payroc-ach-account-holder',
          errorTarget: '.rhinopay-payroc-ach .payroc-ach-account-holder-error',
          placeholder: 'Accountholder Name',
        },
        accountType: {
          target: '.rhinopay-payroc-ach .payroc-ach-account-type',
          errorTarget: '.rhinopay-payroc-ach .payroc-ach-account-type-error',
        },
        achAccountNumber: {
          target: '.rhinopay-payroc-ach .payroc-ach-account-number',
          errorTarget: '.rhinopay-payroc-ach .payroc-ach-account-number-error',
          placeholder: 'Account Number',
        },
        routingNumber: {
          target: '.rhinopay-payroc-ach .payroc-ach-routing-number',
          errorTarget: '.rhinopay-payroc-ach .payroc-ach-routing-number-error',
          placeholder: 'Routing Number',
        },
        submit: {
          target: '.rhinopay-payroc-ach .payroc-ach-submit',
          value: submitLabel,
        },
      },
    },
  });

  hosted.on('submissionSuccess', onSubmissionSuccess);
  if (onError) {
    hosted.on('error', onError);
  }
  hosted.initialize();

  return {
    destroy: () => {
      if (typeof hosted.destroy === 'function') {
        hosted.destroy();
      }
    },
  };
}
